import React, { useContext, useRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import clsx from 'clsx';

import { Typography, Icon } from '@americanexpress/aqx-components';
import { StrikethroughOffer } from 'src/universal/components/Strikethrough';
import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';
import { sendDTMCustomEvent } from 'service_modules/models/dtm-tagging';
import {
  DynamicAppModalContext,
  ModalButtonRefContext
} from 'src/universal/components/DynamicApp/redux';
import { getCtaAndLinks, getDynAppOfferBox } from './redux';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';

import {
  getisTier2Offer,
  getOfferContent,
  shouldShowDynamicAppPDP
} from 'page_modules/business-pdp/redux';
import { getLtoOfferBadgeText } from 'page_modules/business-pdp/redux';
import { getOfferStylingDtm } from 'src/universal/utils/offerStyling';
import styles from './__styles__/index.scss?modules';

const DualOfferSeparator = () => (
  <div className={styles.slantedSeparatorContainer}>
    <div className={styles.slantedSeparator} />
    <Icon
      className={styles.slantedSeparatorIcon}
      directory="dls"
      imageName="dls-icon-plus-filled"
    />
  </div>
);

const OfferBox = ({
  offerContent,
  CtaAndLinks,
  isTier2Offer,
  offerStylingBadgeDtm,
  shouldShowDynamicApp,
  dynamicAppContent,
  ltoOfferBadgeText
}) => {
  const {
    offerHeader,
    offerDescription,
    dualOfferHeader,
    dualOfferDescription
  } = offerContent;

  const setIsDynamicModalOpen = useContext(DynamicAppModalContext);
  const thisButtonRef = useRef(null);
  const { setButtonRef } = useContext(ModalButtonRefContext);
  if (!offerHeader) return null;

  const variantRendering = isTier2Offer;

  const lazyLoadCallback = () => {
    sendDTMCustomEvent(offerStylingBadgeDtm);
  };

  const mainComponent = (
    <>
      <div
        className={clsx(styles.topOffer, {
          [styles.variantTopOffer]: variantRendering,
          [styles.hasBadge]: variantRendering
        })}
      >
        {variantRendering && (
          <>
            <LazyScrollMetricTracker
              callBackFunction={lazyLoadCallback}
              startTrackingAfterPznArrival={true}
            />
            <div
              className={clsx(styles.offerBadge, {
                [styles.variantOfferBadge]: variantRendering
              })}
            >
              {ltoOfferBadgeText}
            </div>
          </>
        )}
        <StrikethroughOffer
          className={styles.header}
          header={offerHeader}
          Component="h2"
        />
        {offerDescription && (
          <Typography
            className={clsx(styles.description, {
              [styles.variantDescription]: variantRendering
            })}
          >
            {offerDescription}
          </Typography>
        )}
      </div>
      {dualOfferHeader && <DualOfferSeparator />}
      <div
        className={clsx(styles.bottomOffer, {
          [styles.variantBottomOffer]: variantRendering,
          [styles.dualOffer]: dualOfferHeader
        })}
      >
        <StrikethroughOffer
          header={dualOfferHeader}
          Component="h2"
          className={styles.header}
        />
        {dualOfferDescription && (
          <Typography className={styles.description}>
            {dualOfferDescription}
          </Typography>
        )}
        {shouldShowDynamicApp && (
          <>
            <hr className={styles.dynamicAppLineSeparator} />
            <Typography className={styles.dynamicAppHeader}>
              {dynamicAppContent.title}
            </Typography>
            <Typography className={styles.dynamicAppText}>
              {
                <button
                  className={styles.learnMoreLink}
                  title={dynamicAppContent.learnMoreLink.text}
                  ref={thisButtonRef}
                  onClick={() => {
                    setButtonRef(thisButtonRef);
                    setIsDynamicModalOpen();
                    sendDTMClickEvent(dynamicAppContent.learnMoreLink.dtm);
                  }}
                >
                  {dynamicAppContent.learnMoreLink.text}
                </button>
              }
              {dynamicAppContent.subTitle}
            </Typography>
          </>
        )}
        <div
          className={clsx({
            [styles.ctas]: shouldShowDynamicApp
          })}
        >
          {CtaAndLinks}
        </div>
      </div>
    </>
  );

  return <div className={styles.container}>{mainComponent}</div>;
};

const mapStateToProps = (state, { shortName, params }) => ({
  offerContent: getOfferContent(state, shortName),
  CtaAndLinks: getCtaAndLinks(params?.eep)(state),
  isTier2Offer: getisTier2Offer(state),
  offerStylingBadgeDtm: getOfferStylingDtm(state, shortName),
  shouldShowDynamicApp: shouldShowDynamicAppPDP(state),
  dynamicAppContent: getDynAppOfferBox(state),
  ltoOfferBadgeText: getLtoOfferBadgeText(state, shortName)
});

export default withRouter(connect(mapStateToProps)(OfferBox));
